import { Button } from '@azelis/ui/components/button';
import {
  Card,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@azelis/ui/components/card';
import { PageLayout, PageLayoutContent } from '@azelis/ui/components/pageLayout';
import { useSearch } from '@tanstack/react-router';
import { LoaderCircle } from 'lucide-react';

import { authErrorMessage } from '@/auth/auth-errors';
import { useAuth } from '@/auth/auth-provider';

export default function Login() {
  const { login, isLoggingIn, loginError } = useAuth();
  const { error } = useSearch({ from: '/login' });

  // The popup reports its own failures; the search param carries the rest.
  const shownError = loginError ?? error;

  return (
    <PageLayout>
      <PageLayoutContent className="items-center justify-center">
        <Card className="w-full max-w-md">
          <CardHeader className="justify-items-center gap-4 text-center">
            <CardTitle className="text-2xl leading-8 font-semibold">
              Sign in
            </CardTitle>
            <CardDescription className="text-base leading-6">
              Sign in with your Azelis account to continue.
            </CardDescription>
          </CardHeader>
          {shownError ? (
            <p
              role="alert"
              className="px-6 text-left text-sm text-red-700">
              {authErrorMessage(shownError)}
            </p>
          ) : null}
          <CardFooter>
            <Button
              className="w-full"
              disabled={isLoggingIn}
              aria-busy={isLoggingIn}
              onClick={login}>
              {isLoggingIn ? (
                <>
                  <LoaderCircle
                    aria-hidden
                    className="animate-spin"
                    data-icon="inline-start"
                  />
                  Waiting for Microsoft…
                </>
              ) : (
                'Sign in with Microsoft'
              )}
            </Button>
          </CardFooter>
        </Card>
      </PageLayoutContent>
    </PageLayout>
  );
}
